if (!customElements.get('featured-products')) {
    class FeaturedProducts extends HTMLElement {
        constructor() {
            super();
            this.selector = {
                main: this.querySelector('.featured-products')
            };
            this.state = {
                isDown: false,
                startX: null,
                scrollLeft: null
            };
            this.load();
        }
     load() {
            if (this.selector.main) {
                this.selector.main.addEventListener('mousedown', event => {
                    this.state.isDown = true;
                    this.selector.main.classList.add('active');
                    this.state.startX = event.pageX - this.selector.main.offsetLeft;
                    this.state.scrollLeft = this.selector.main.scrollLeft;
                });

                this.selector.main.addEventListener('mouseleave', event => {
                    this.state.isDown = false;
                    this.selector.main.classList.remove('active');
                });

                this.selector.main.addEventListener('mouseup', event => {
                    this.state.isDown = false;
                    this.selector.main.classList.remove('active');
                    if(event.target.closest('.colour-swatch-label') || event.target.closest('.featured-quick-view-modal-btn') || event.target.closest('.spf-product-card__image-wrapper')) return;
                });

                this.selector.main.addEventListener('mousemove', event => {
                    if(!this.state.isDown) return;
                    event.preventDefault();
                    const x = event.pageX - this.selector.main.offsetLeft;
                    const walk = (x - this.state.startX) * 2;
                    const newScrollLeft = this.state.scrollLeft - walk;
                    this.selector.main.scrollLeft = newScrollLeft;
                });
                this.selector.main.addEventListener('click', event => {
                    if(event.target.closest('.colour-swatch-label')) {
                        const variantImages = event.target.closest('.spf-product-card__inner').querySelectorAll('img.spf-product-card__image');
                        event.target.closest('.spf-product-card__inner').querySelector('.product-tile__image-container > .spf-product-card__image-wrapper').href = event.target.closest('.colour-swatch-label').dataset.variantUrl;
                        if(variantImages.length > 1) {
                            variantImages.forEach((image,index) => {
                                if(event.target.closest('.colour-swatch-label').dataset.colourValue === image.dataset.colourHandle) {
                                    if(index == 1) {
                                        variantImages[1].classList.remove('spf-product-card__image-secondary');
                                        variantImages[0].classList.add('spf-product-card__image-secondary');
                                    } else {
                                        variantImages[1].classList.add('spf-product-card__image-secondary');
                                        variantImages[0].classList.remove('spf-product-card__image-secondary');
                                    }
                                    image.classList.add('spf-product-card__image-main');
                                    image.classList.remove('spf-product-card__image-hidden');
                                } else {
                                    image.classList.add('spf-product-card__image-hidden');
                                    image.classList.remove('spf-product-card__image-main');
                                }
                            })
                        }
                   }
                })
            }
        }
    }
   customElements.define('featured-products', FeaturedProducts);
}